import { KB_COMMISSION } from "../../actions/type";

export default function ledger(state = {}, action) {
    switch (action.type) {
        case KB_COMMISSION:
            return action.payload;;
        default:
            return state
    }
}